"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAzureTokens = exports.loginRequest = exports.msalConfig = void 0;
var features_1 = require("../features");
Object.defineProperty(exports, "msalConfig", { enumerable: true, get: function () { return features_1.msalConfig; } });
Object.defineProperty(exports, "loginRequest", { enumerable: true, get: function () { return features_1.loginRequest; } });
Object.defineProperty(exports, "getAzureTokens", { enumerable: true, get: function () { return features_1.getAzureTokens; } });
//# sourceMappingURL=index.js.map